import template from './am-group-details-form.html';
class AmGroupDetailsController {
  constructor() {
    'ngInject';
    this.status = '';
    this.group = {};
    this.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }
  $onInit() {
    this.formName = this.formName || 'contractDetailsForm';
    this.outGroup = {};
    this.status = '';
  }
  $onChanges(changes) {
    const { inGroup } = changes;

    if (inGroup && inGroup.currentValue) {
      this.outGroup = inGroup.currentValue;
    }
  }
  $onDestroy() { }
}

export default {
  template,
  controller: AmGroupDetailsController,
  controllerAs: 'groupDTFVm',
  bindings: {
    inGroup: '<',
    outGroup: '=',
    showEmail: '=',
    formName: '='
  }
};
